import React from "react";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton, CardImg, OverlayTrigger } from 'react-bootstrap';
import { context } from '../../AppContext';
import Locale from "../../../locale/Locale";
import Pager from "../components/Pager";
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import AlertHelper from '../../helpers/alert';
import HistoryItem from './HistoryItem';

export default class HistoryList extends React.Component {

    state = {
        loading: false,
        loadedRange: [ new Date(), new Date() ],
        timeStart: new Date(Date.now() - 7*24*60*60*1000),
        items: null
    };

    componentDidMount() {
        if (this.state.items === null) {
            this.updateData();
        }
    }

    async updateData() {
        this.setState({ 
            loading: true
        });
        let items = await context.makeRequest("Site.getHistory", {
            siteId: this.props.site.id,
            range: [ this.state.timeStart, this.state.loadedRange[0] ],
            filters: [
                [
                    {
                        'Control': {
                            rel: 'not', value: ['', 'null']
                        },
                        'ParamName': { 
                            //rel: 'not', 
                            value: [
                                //'Restricted', 'Synchronize', 'RestrictedMaximumPowerLevel', 'RestrictedMinimumPowerLevel'
                                'Status', 'PowerLevel', 'LightName', 'SetPoint', 'ControlMode', 'Theme', 'Brightness'
                            ]
                        }
                    },
                    {
                        'Control': ['',  'null'],
                        'ParamName': [
                            'Connected', 'AwayMode', 'FreezeProtectStart', 'FreezeProtectPaused', 'PausedUntil',
                            'CurrentAcidMixEvent', 'CurrentSaltChlorinatorMixEvent', 'CurrentLiquidChlorineMixEvent',
                            'Theme', 
                            'ScheduleEventCancelled', 'ScheduleEventInterrupted', 'ScheduleEventResumed'
                        ]
                    },
                    {
                        'Device': this.props.site.uuid,
                        'ParamName': [ 'Mode' ]
                    },
                    {
                        'Device': this.props.site.uuid,
                        'Param': [ 'Mode' ]
                    }
                ]
            ]
        });
        let prevByName = {};
        let ignoredParams = {};
        items.result = items.result?.reverse()
            .filter((item) => {
                let pn = item.ParamName || item.Param;
                let state = null;
                let prevState = null;
                let control = this.props.config.Controls.find(ctrl => ctrl.UUID === item.Control);

                try {
                    state = JSON.parse(item.Status);
                } catch (e) {
                    state = item.Status;
                }
                try {
                    prevState = JSON.parse(item.PrevStatus);
                } catch (e) {
                    prevState = item.PrevStatus;
                }
                let result = true;
                // Filter out some events which are just 'off' events
                if (
                        ['CurrentAcidMixEvent', 'CurrentSaltChlorinatorMixEvent', 'CurrentLiquidChlorineMixEvent'].indexOf(pn) !== -1
                    ) {
                    if (state == null) { 
                        result = false;
                    } else if (prevState && state && prevState.UUID === state.UUID) {
                        result = false;
                    }
                }
                if (
                    ['AlertState'].indexOf(pn) !== -1 && state == null
                ) {
                    result = false;
                }
                if (['Restricted', 'Synchronize', 'RestrictedMaximumPowerLevel', 'RestrictedMinimumPowerLevel'].indexOf(pn) !== -1)
                    result = false;
                if (control?.Type === "Light" && pn === "PowerLevel")
                    result = false;
                if (control?.Type !== "Light" && pn === "LightName")
                    result = false;
                if (item.PrevStatus === "DISABLED" || item.Status === "DISABLED")
                    result = false;

                if (result && [
                        'FreezeProtectStart', 'FreezeProtectPaused', 'CurrentAcidMixEvent', 'CurrentSaltChlorinatorMixEvent', 'CurrentLiquidChlorineMixEvent', 'AwayMode', 'Connected'
                    ].indexOf(pn) !== -1
                ) {
                    if (prevByName[pn]?.Status === item.Status || item.PrevStatus === item.Status) {
                        result = false;
                    } else if (pn === "CurrentSaltChlorinatorMixEvent") { // This might not be needed anymore
                        let prevDetails = JSON.parse(prevByName[pn]?.Status || "{}");
                        if (state.StartDateTime === prevDetails.StartDateTime) {
                            result = false;
                        }
                    }
                    prevByName[pn] = item;
                }
                
                if (item.PrevStatus && item.Status === item.PrevStatus) {
                    result = false;
                }

                if (!result)
                    ignoredParams[pn] = pn; 
                return result;
            }
        ).reverse();
        this.setState({ 
            items: items.result,
            loading: false
        });
    }

    render(props) {
        return (
            <div style={{  }}>
                { this.extraElement }
                <div style={{ }}>
                    <Button 
                        style={{ marginRight: 10 }}
                        onClick={ () => this.updateData() }
                    >
                        <MdIcons.MdRefresh />{ Locale.gettext("Refresh") }
                    </Button>
                </div>
                <div style={{  }}>
                {
                    this.state.loading ? "Loading..." : 
                    this.state.items?.length > 0 ? 
                        (
                            <div>
                                <table style={{ width: '100%', border: '1px solid' }} cellPadding={ 5 }>
                                    <thead>
                                    <tr style={{ fontWeight: 'bold', border: '1px solid' }}>
                                        <td style={{ width: 200 }}>{ Locale.gettext("Time")}</td>
                                        <td style={{ }}>{ Locale.gettext("By") }</td>
                                        <td style={{  }}>{ Locale.gettext("Action") }</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    { this.state.items?.map((historyItem, key) => {
                                        return (
                                            <HistoryItem 
                                                key={ "history_item_" + key }
                                                config={ this.props.config }
                                                allConfigs={ this.props.allConfigs }
                                                record={ historyItem }
                                            />
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        ) : Locale.gettext("No history found")
                }
                </div>
            </div>
        );
    }
}